// extracted by mini-css-extract-plugin
export default {"caseStatusHistory":"styles_caseStatusHistory__lzyJ2","heading":"styles_heading__mS1jE"};